import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # UserOption
 *
 * 미션 - 사용자 선택값 모델
 */

export const Option = types.model('option', {
  value: types.maybeNull(types.string),
  option: types.maybeNull(types.string),
});
type TOption = Instance<typeof Option>;
export interface IOption extends TOption {}
export const createOption = () => types.optional(Option, {} as TOption);

export const UserOption = types
  .model('UserOption')
  // --------------------------------------------------------------------------
  .props({
    input_type: types.maybeNull(types.string),
    options: types.maybeNull(types.array(Option)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model userOption --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IUserOptionSnapshot>) => {
      const newProps = { ...self, ...props } as IUserOption;
      (Object.keys(newProps) as TUserOptionKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUserOption = Instance<typeof UserOption>;
type TUserOptionSnapshot = SnapshotOut<typeof UserOption>;

export interface IUserOption extends TUserOption {}
export type TUserOptionKeys = keyof TUserOptionSnapshot & string;
export interface IUserOptionSnapshot extends TUserOptionSnapshot {}
export const createUserOption = () => types.optional(UserOption, {} as TUserOption);
